import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "image-menu" }

import { ref, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ImageOrShapeFlip, PPTElement, PPTLineElement, PPTTextElement, PPTShapeElement } from '@/types/slides'
import { getImageDataURL } from '@/utils/image'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import CheckboxButton from '@/components/CheckboxButton.vue'
import CheckboxButtonGroup from '@/components/CheckboxButtonGroup.vue'
import FileInput from '@/components/FileInput.vue'
import {
  FlipVertically, 
  FlipHorizontally, 
  Transform,
} from '@icon-park/vue-next'
import {
  Tooltip,
  message,
} from 'ant-design-vue'
import { values } from 'lodash'

type ExcludePPTLineElement<T> = T extends PPTLineElement ? never : T;

// 使用新的类型定义排除 PPTLineElement 的 PPTElement
type PPTElementWithoutLine = ExcludePPTLineElement<PPTElement>;

// 获取当前选中元素外层边框

export default /*@__PURE__*/_defineComponent({
  __name: 'ImageMenuContent',
  setup(__props) {

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(mainStore)
const { currentSlide } = storeToRefs(useSlidesStore())

const flipH = ref(false)
const flipV = ref(false)
const imageText = ref('')

watch(handleElement, () => {
  if (handleElement.value && (handleElement.value.type === 'image' || handleElement.value.type === 'shape')) {
    flipH.value = !!handleElement.value.flipH
    flipV.value = !!handleElement.value.flipV
  }
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateFlip = (flipProps: ImageOrShapeFlip) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props: flipProps })
  addHistorySnapshot()
}

const clipPanelVisible = ref(false)

// // 打开自由裁剪
// const clipImage = () => {
//   mainStore.setClipingImageElementId(handleElementId.value)
//   clipPanelVisible.value = false
// }

// 替换图片（保持当前的样式）
const replaceImage = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  // 限制图片大小 10M
  const maxLength = 10 * 1024 * 1024
  if (imageFile.size > maxLength) {
    message.error('图片大小不能超过10M')
    return
  }
  getImageDataURL(imageFile).then(dataURL => {
    const props = { src: dataURL }
    slidesStore.updateElement({ id: handleElementId.value, props })
  })
  addHistorySnapshot()
}

const haveAI = async () => {
  // debugger
  let imgTxt = ''

  if (!handleElement.value) return imgTxt
  let outEL = null
  let internalEL = null
  if (handleElement.value) {
    outEL = await getOuterBorder(currentSlide.value.elements as PPTElementWithoutLine[], handleElement.value as PPTElementWithoutLine)
  }
  if (outEL) {
    const outShape = outEL.filter(el => el.type === 'shape' && el.id !== handleElement.value?.id)
    // console.log('outShape:', outShape)
    
    if (outShape.length > 0) {
      // 获取外层元素文字
      internalEL = await getSurroundingElements(currentSlide.value.elements as PPTElementWithoutLine[], outShape[0] as PPTElementWithoutLine)
    }
  }
  // console.log('internalEL:', internalEL)
  if (!internalEL) {
    // message.error('未获取到图片描述')
    return imgTxt
  } 
  // 图片描述
  const imgDesc = internalEL.filter(el => el.type === 'text')
  // console.log('imgDesc:', imgDesc)
  if (imgDesc.length === 0) {
    const shapDesc = internalEL.filter(el => el.type === 'shape')
    const textShap = shapDesc.filter(el => (el as PPTShapeElement).text?.content)
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = (textShap[0] as PPTShapeElement).text?.content || ''
    imgTxt = tempDiv.innerText
  }
  else {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = (imgDesc[0] as PPTTextElement)?.content
    imgTxt = tempDiv.innerText
  }
  
  if (!imgTxt || imgTxt.trim() === '' || imgTxt === 'undefined') {
    // message.error('未获取到图片描述')
    return imgTxt
  }
  return imgTxt
}

const onAIClick = () => {
  // console.log('imageText :', imageText.value)
  if (imageText.value) {
    window.parent.postMessage({ action: 'AIImgClicked', text: imageText.value }, '*')
  }
}

// 定义一个新的类型，排除 PPTLineElement
const getOuterBorder = (currentEL: PPTElementWithoutLine[], handleEL: PPTElementWithoutLine) => {
  if (!handleEL) return []
  // debugger
  const surroundingElements = [handleEL]
  const { left, top, width, height } = handleEL
  const right = left + width
  // console.log('elcurrentEL:', left, top, width, height)
  currentEL.forEach(el => {
    // console.log('elaaa:', el)
    if (el.id !== handleEL.id) {
      // debugger
      const { left: elLeft, top: elTop, width: elWidth, height: elHeight } = el
      // console.log('elaaa:', elLeft, elTop, elWidth, elHeight)
      // 获取外边框
      if (elLeft <= left && elLeft + elWidth >= right && elTop <= top && elTop + elHeight >= top + height) {
        surroundingElements.push(el)
      }
    }
  })
  return surroundingElements
}

// 获取当前选中元素边界包含的所有元素
const getSurroundingElements = (currentEL: PPTElementWithoutLine[], handleEL: PPTElementWithoutLine) => {
  if (!handleEL) return []

  const surroundingElements = [handleEL]
  const { left, top, width, height } = handleEL
  // console.log('left:', left, 'top:', top, 'width:', width, 'height:', height)
  const right = left + width
  currentEL.forEach(el => {
    if (el.id !== handleEL.id) {
      const { left: elLeft, top: elTop, width: elWidth, height: elHeight } = el
      // 获取内部元素
      if (elLeft >= left && elLeft + elWidth <= right && elTop >= top && elTop + elHeight <= top + height) {
        surroundingElements.push(el)
      }
    }
  })
  return surroundingElements
}

onMounted(async () => {
  imageText.value = await haveAI()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CheckboxButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "垂直翻转"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: flipV.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (updateFlip({ flipV: !flipV.value })))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FlipVertically))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "水平翻转"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: flipH.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (updateFlip({ flipH: !flipH.value })))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FlipHorizontally))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Tooltip), {
      mouseLeaveDelay: 0,
      mouseEnterDelay: 0.5,
      title: "替换图片"
    }, {
      default: _withCtx(() => [
        _createVNode(FileInput, {
          class: "file-checkbox",
          onChange: _cache[2] || (_cache[2] = files => replaceImage(files)),
          style: {"cursor":"pointer"}
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Transform))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (imageText.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "btn-ai",
          id: "btn-ai",
          onClick: onAIClick
        }, "AI"))
      : _createCommentVNode("", true)
  ]))
}
}

})